import type {
  NvoqMessage,
  ParsedDictationChunk,
  SironaSubstitution,
} from '../createNvoqWebsocketFactory';
import { SIRONA_SUBSTITUTION_REGEX } from './utils';
import { createSyntheticSubstitutions } from './createSyntheticSubstitutions';
import { getVoiceCommandTargetFromAction } from './getVoiceCommandTargetFromAction';
import { isObject } from 'utils/isObject';
import pipe from 'ramda/es/pipe';

export const createDictationChunksFromNvoqStableText = (
  msg: NvoqMessage
): ParsedDictationChunk[] => {
  return pipe(createSyntheticSubstitutions, parseNvoqStableText)(msg);
};

/**
 * Parses substitutions from nVoq text. Will look something like this:
 * Text <srna>{something: 'here'}</srna> more text
 */
export const parseNvoqStableText = (msg: NvoqMessage): ParsedDictationChunk[] =>
  msg.data.text.split(SIRONA_SUBSTITUTION_REGEX).map((textFragment) => {
    // See if it's a stringified object we can parse, otherwise return a nVoqMessage
    try {
      const substitution: SironaSubstitution = JSON.parse(textFragment);

      // Substitutions must be an object, otherwise we throw and insert what nVoq gives us
      if (!isObject(substitution)) {
        throw new Error('Not a valid substitution as it is NOT an object!');
      }

      return {
        type: 'SUBSTITUTION',
        payload: {
          target: getVoiceCommandTargetFromAction(substitution.action),
          ...substitution,
        },
      } as ParsedDictationChunk;
    } catch (err: any) {
      return {
        type: 'TEXT',
        payload: {
          ...msg,
          data: { ...msg.data, text: textFragment, substitutedText: textFragment, markers: [] },
        },
      } as ParsedDictationChunk;
    }
  });
